// 防疫互助相关路由
export default {
  routes: [
    // 一级页
    {
      path: '/(\\s*)appTest(\\d*)/(\\s*)lv1Page(\\d*)',
      name: 'appTestLv1Page',
      meta: {
        title: '1级页面'
      },
      component: () => import('../views/test/lv1Page.vue')
    },
    // 二级页
    {
      path: '/(\\s*)appTest(\\d*)/(\\s*)lv2Page(\\d*)',
      name: 'appTestLv2Page',
      meta: {
        title: '2级页面'
      },
      component: () => import('../views/test/lv2Page.vue')
    },
    // 三级页
    {
      path: '/(\\s*)appTest(\\d*)/(\\s*)lv3Page(\\d*)',
      name: 'appTestLv3Page',
      meta: {
        title: '3级页面'
      },
      component: () => import('../views/test/lv3Page.vue')
    },
    // 无级别级页
    {
      path: '/(\\s*)appTest(\\d*)/(\\s*)noLevelPage(\\d*)',
      name: 'appTestNoLevelPage',
      meta: {
        title: '普通页面'
      },
      component: () => import('../views/test/noLevelPage.vue')
    }
    // 测试
    // {
    //   path: '/(\\s*)appTest(\\d*)/(\\s*)dz(\\d*)',
    //   name: 'dz',
    //   meta: {
    //     title: '德州'
    //   },
    //   component: () => import('../views/test/dz.vue')
    // }
  ]
}
